(() => {
  if (customElements.get('pf-money-back-guarantee')) return;

  class PfMoneyBackGuarantee extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.controller = new AbortController();
      const { signal } = this.controller;

      this.trigger = this.querySelector('[data-pf-guarantee-open]');
      this.dialog = this.querySelector('dialog');
      this.closeButtons = this.querySelectorAll('[data-pf-guarantee-close]');

      if (!this.trigger || !this.dialog) return;

      this.trigger.addEventListener('click', () => this.openDialog(), { signal });
      this.dialog.addEventListener('close', () => this.onDialogClose(), { signal });
      this.dialog.addEventListener('cancel', () => { this.closeMethod = 'escape'; }, { signal });
      this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event), { signal });

      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.closeMethod = 'button';
          this.dialog.close();
        }, { signal });
      });

      this.observeImpression();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      document.body.classList.remove('pf-guarantee-modal-open');
    }

    openDialog() {
      this.lastFocusedElement = document.activeElement;

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.body.classList.add('pf-guarantee-modal-open');
      this.track('pf_guarantee_modal_open');
    }

    onDialogClose() {
      document.body.classList.remove('pf-guarantee-modal-open');
      this.track('pf_guarantee_modal_close', { method: this.closeMethod || 'button_or_native' });
      this.closeMethod = '';

      if (this.lastFocusedElement instanceof HTMLElement) {
        this.lastFocusedElement.focus();
      }
    }

    handleBackdropClick(event) {
      if (event.target !== this.dialog) return;

      const rect = this.dialog.getBoundingClientRect();
      const clickedInside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;

      if (!clickedInside) {
        this.closeMethod = 'backdrop';
        this.dialog.close();
      }
    }

    observeImpression() {
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
          if (!visible) return;
          this.track('pf_guarantee_card_impression');
          this.observer.disconnect();
        },
        { threshold: [0.5] }
      );

      this.observer.observe(this);
    }

    track(eventName, extra = {}) {
      if (window.Shopify && window.Shopify.designMode) return;

      const payload = {
        event: eventName,
        component: 'money_back_guarantee_card',
        section_id: this.dataset.sectionId || '',
        product_id: this.dataset.productId || '',
        product_handle: this.dataset.productHandle || '',
        ...extra,
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, detail: payload }));
    }
  }

  customElements.define('pf-money-back-guarantee', PfMoneyBackGuarantee);
})();